module.exports = __webpack_public_path__ + "img/xiaomaiICON.e6859ef0.png";